module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("May 19, 1962")]), _vm._v(" "), _c('p', {
    staticClass: "indent_top"
  }, [_c('i', [_vm._v("It must have been friction... or even just a spark.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Something ignited the fuel, and rather than just burning, it exploded.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_top"
  }, [_c('b', [_vm._v("It must have been friction... or even just a spark.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_vm._v("Something ignited the fuel, and rather than just burning, it exploded.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_vm._v("The thunderous explosion could be heard several blocks away. On an otherwise lazy weekend morning, men, women, and children stopped what they were doing. They froze in place, with some even peering up anxiously at the sky, believing an enemy attack was never too far off.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_vm._v("Back in the middle of the charred, splintered garage, a teenage boy stood stunned in place with chest, arms, and face badly burned and gushing blood from shrapnel wounds.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_vm._v("I was surrounded by blackness, but there was no pain—yet.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('b', [_vm._v("I realized the rocket had exploded. I knew I was seriously injured...")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4145ca30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm03.vue
// module id = 78
// module chunks = 0